<div class="agent-informations-container" *ngIf="product">
    <!-- Anagraphics Section -->
    <div class="section">
      <div class="section-header">
        <span>{{ "inventory.product_information" | translate }}</span>
        <button
          *appHasPermission="{ module: 'product', action: 'edit' }"
          class="action-btn secondary-btn icon-btn"
          aria-label="Edit Inventory"
          (click)="edit_product_infos()"
        >
          <span class="icon">
            <app-svg-icon svgIcon="pen-cc"></app-svg-icon>
          </span>
        </button>
      </div>
      <div class="info-list">
        <div class="title">
          <ui-copyable size="big" [value]="product.name" [label]="'common.name' | translate">
            {{product.name}}
          </ui-copyable>
        </div>
        <div class="info-row" *appFieldVisible="{ module: 'product', field: 'brand' }">
          <span class="label">{{
            "brands.brand" | translate
          }}</span>
          <ui-copyable [value]="product.brand?.name" [label]="'brands.brand' | translate">
            <span class="value truncate" style="max-width: 200px;" [title]="product.brand?.name">{{product.brand?.name ?? '--'}}</span>
          </ui-copyable>
        </div>
        <div class="info-row" *appFieldVisible="{ module: 'product', field: 'expiry_date' }">
          <span class="label">{{
            "inventory.expiration_date" | translate
          }}</span>
          <span class="value truncate" style="max-width: 200px;">{{ product.expiry_date ?? '--' }}</span>
        </div>
        <!-- ERP reference. Renders only when the API exposes erp_id. -->
        <div class="info-row" *ngIf="product.erp_id">
          <span class="label">{{
            "inventory.erp_id" | translate
          }}</span>
          <ui-copyable [value]="product.erp_id" [label]="'inventory.erp_id' | translate">
            <span class="value">{{ product.erp_id }}</span>
          </ui-copyable>
        </div>
        <div class="info-row">
          <span class="label">{{
            "inventory.sku" | translate
          }}</span>
          <ui-copyable [value]="getProductElementRawValue('sku')" [label]="'inventory.sku' | translate">
            <span class="value">{{ getProductElementValue('sku')}}</span>
          </ui-copyable>
        </div>
        <div class="info-row" *appFieldVisible="{ module: 'product', field: 'barcode' }">
          <span class="label">{{
            "inventory.ean" | translate
          }}</span>
          <ui-copyable [value]="getProductElementRawValue('barcode')" [label]="'inventory.ean' | translate">
            <span class="value" style="font-weight: 500;">{{ getProductElementValue('barcode')}}</span>
          </ui-copyable>
        </div>
        <div class="info-row">
          <span class="label">{{
            "inventory.extra_identifiers" | translate
          }}</span>
          <span class="value">
            {{ getExtraIdentifiers().join(', ') }}
          </span>
        </div>
        <div class="info-row">
          <span class="label">{{
            "common.status" | translate
          }}</span>
          <ui-status-badge
            size="small"
            [tone]="statusTone(product)"
            [label]="getStatusTranslation(product.status)"
          ></ui-status-badge>
          <!-- <span class="value tags">
            <ng-container *ngFor="let tag of agent.tags">
              <span class="tag" [ngStyle]="{ background: tag.color }">
                {{ tag.name }}
              </span>
            </ng-container>
          </span> -->
        </div>
        <div class="info-row">
            <span class="label">{{
              "inventory.product_type" | translate
            }}</span>
            <span class="tag">{{"inventory." + getProductType(product) | translate}}</span>
        </div>
        <div class="info-row column-info">
          <span class="label">{{
              "common.description" | translate
            }}</span>
            <div class="value description-container" *ngIf="product.description" else noDescription>
              <span
                class="value description-text"
                [title]="product.description"
                [innerHTML]="getDisplayDescription()"
              ></span>
              <button
                *ngIf="shouldShowReadMoreButton('description')"
                class="read-more-btn"
                (click)="toggleDescriptionExpansion('description')"
                type="button"
              >
                {{ isDescriptionExpanded ? ('common.show_less' | translate) : ('common.show_more' | translate) }}
              </button>
            </div>
            <ng-template #noDescription>
              <span class="value">--</span>
            </ng-template>
      </div>
        <div class="section gray-section" *ngIf="product.attributes && product.attributes.length > 0">
          <div class="section-header">
            <span>{{"inventory.product_details.variant_selection" | translate}}</span>
          </div>
          <div class="info-list">
            <div class="info-row attribute-row" *ngFor="let attr of product.attributes">
                <span class="label attribute-label">{{attr.name}}</span>
                <div class="info-row badge-container">
                  <span *ngFor="let value of attr.values" class="badge white" (click)="selectAttributeValue(attr.name, value)" [class.selected]="isSelected(attr.name, value)" [title]="value">{{value}}</span>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr *appFieldVisible="{ module: 'product', field: 'image' }"/>
    <ng-container *appFieldVisible="{ module: 'product', field: 'image' }">
      <div class="section" *ngIf="getAllImages().length > 0">
        <div class="images-preview-container">
          <!-- Main image display -->
          <div class="main-image-container">
            <button
              *ngIf="getAllImages().length > 1" 
              class="action-btn secondary-btn icon-btn nav-arrow left"
              aria-label="Previous image"
              (click)="prevImage()"
            >
              <span class="icon">
                <app-svg-icon svgIcon="arrow-left"></app-svg-icon>
              </span>
            </button>
            <img 
              [src]="getAllImages()[currentImageIndex]" 
              class="main-image"
              (error)="onImageError($event)"
            />
            <button
              *ngIf="getAllImages().length > 1" 
              class="action-btn secondary-btn icon-btn nav-arrow right"
              aria-label="Next imagey"
              (click)="nextImage()"
            >
              <span class="icon">
                <app-svg-icon svgIcon="arrow-right"></app-svg-icon>
              </span>
            </button>
            <button
              *appHasPermission="{ module: 'product', action: 'edit' }"
              class="delete-image-btn main-delete-btn"
              aria-label="Delete image"
              (click)="deleteImage(currentImageIndex, $event)"
              title="Delete image"
            >
              <app-svg-icon svgIcon="delete_btn"></app-svg-icon>
            </button>
          </div>
          
          <!-- Thumbnail navigation -->
          <div class="thumbnails-container" *ngIf="getAllImages().length > 0">
            <div 
              *ngFor="let image of getAllImages(); let i = index" 
              class="thumbnail"
              [class.active]="i === currentImageIndex"
              (click)="selectImage(i)"
            >
              <img 
                [src]="image" 
                (error)="onImageError($event)"
              />
              <button
                *appHasPermission="{ module: 'product', action: 'edit' }"
                class="delete-image-btn thumbnail-delete-btn"
                aria-label="Delete image"
                (click)="deleteImage(i, $event)"
                title="Delete image"
              >
                <app-svg-icon svgIcon="delete_btn"></app-svg-icon>
              </button>
            </div>
            <!-- Upload thumbnail -->
            <div
              *appHasPermission="{ module: 'product', action: 'edit' }"
              class="thumbnail upload-thumbnail"
              (click)="triggerFileInput()"
              title="Add image"
            >
              <input 
                type="file" 
                #fileInput
                accept=".png,.jpg,.jpeg,.webp,.gif"
                multiple
                (change)="onFileSelected($event)"
                style="display: none;"
              />
              <span class="upload-icon">+</span>
            </div>
          </div>
        </div>
      </div>
      <div class="section" *ngIf="getAllImages().length <= 0">
        <div class="upload-images-container" *appHasPermission="{ module: 'product', action: 'edit' }" (click)="triggerFileInput()">
          <img src="assets/icones/upload-icon.svg" alt="">
          <input
          type="file"
          #fileInput
          accept=".png,.jpg,.jpeg,.webp,.gif"
          multiple
          (change)="onFileSelected($event)"
          style="display: none;"
        />
          <span>
            {{ "common.upload_images" | translate }}
          </span>
        </div>
      </div>
    </ng-container>
    <hr />
    <div class="section">
      <div class="section-header">
        <span>{{ "inventory.technical_details" | translate }}</span>
        <button
          *appHasPermission="{ module: 'product', action: 'edit' }"
          class="action-btn secondary-btn icon-btn"
          aria-label="Edit Inventory"
          (click)="editTechnical()"
        >
          <span class="icon">
            <app-svg-icon svgIcon="pen-cc"></app-svg-icon>
          </span>
        </button>
      </div>
      <div class="info-list">
        <div class="info-row column-info">
          <div class="value description-container" *ngIf="getDisplayTechnicalDetails()">
            <span
              class="value description-text"
              [title]="product.technical_details"
              [innerHTML]="getDisplayTechnicalDetails()"
            ></span>
            <button
              *ngIf="shouldShowReadMoreButton('technical_details')"
              class="read-more-btn"
              (click)="toggleDescriptionExpansion('technical_details')"
              type="button"
            >
              {{ isTechnicalDetailsExpanded ? ('common.show_less' | translate) : ('common.show_more' | translate) }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="section">
      <div class="section-header">
        <span>{{ "inventory.additional_documents" | translate }}</span>
        <button
          *appHasPermission="{ module: 'product', action: 'edit' }"
          class="action-btn secondary-btn icon-btn"
          aria-label="Edit Inventory"
          (click)="triggerDocumentInput()"
        >
          <span class="icon">
            <input 
            type="file" 
            #documentInput
            (change)="addDocument($event)"
            style="display: none;"
          />
            <app-svg-icon svgIcon="plus-cc"></app-svg-icon>
          </span>
        </button>
      </div>
      <div class="info-list">
        <ng-container *ngFor="let file of selectedFiles; let index = index">
          <div class="info-row file-info">
            <div class="info-row">
              <img src="assets/icones/file-icon.svg" alt="">
              <span class="value truncate" style="max-width: 200px;" [title]="file.filename">{{
                file.filename
              }}</span>
            </div>
            <div class="info-row">
              <button (click)="download(file.data, file.filename, file.content_type)">
                <app-svg-icon svgIcon="download"></app-svg-icon>
              </button>
              <button *appHasPermission="{ module: 'product', action: 'edit' }" (click)="removeDocument(index)">
                <app-svg-icon svgIcon="delete_btn"></app-svg-icon>
              </button>
            </div>
          </div>
          <hr class="small-separator" />
        </ng-container>
      </div>
    </div>
    <hr *ngIf="isPricingVisible$ | async" />
    <div class="section" *ngIf="isPricingVisible$ | async">
      <div class="section-header">
        <span>{{ "inventory.pricing" | translate }}</span>
        <button
          *appHasPermission="{ module: 'product', action: 'edit' }"
          class="action-btn secondary-btn icon-btn"
          aria-label="Edit Inventory"
          (click)="editPricing()"
        >
          <span class="icon">
            <app-svg-icon svgIcon="pen-cc"></app-svg-icon>
          </span>
        </button>
      </div>
      <div class="info-list">
        <div class="info-row" *appFieldVisible="{ module: 'product', field: 'sales_price' }">
            <span class="label">{{
              "common.retail_price" | translate
            }}</span>
            <div class="value currency-price-container">
              <span>{{getProductElementValue('sales_price')}}</span>
              <span *ngFor="let currencyPrice of getCurrencyPrices('retail_price')"
                    class="currency-price">
                {{formatCurrencyPrice(currencyPrice)}}
              </span>
            </div>
        </div>
        <div class="info-row" *appFieldVisible="{ module: 'product', field: 'cost' }">
          <span class="label">{{
            "inventory.product_cost" | translate
          }}</span>
          <div class="value currency-price-container">
            <span>{{getProductElementValue('cost')}}</span>
            <span *ngFor="let currencyPrice of getCurrencyPrices('cost')"
                  class="currency-price">
              {{formatCurrencyPrice(currencyPrice)}}
            </span>
          </div>
        </div>
        <!-- <div class="info-row">
          <span class="label">{{
            "common.taxes" | translate
          }}</span>
          <span class="value">{{product.taxes}}</span>
        </div> -->
      </div>
    </div>
    <!-- <hr />
    <div class="section">
      <div class="section-header">
        <span>{{ "inventory.packaging" | translate }}</span>
        <button
          class="action-btn secondary-btn icon-btn"
          aria-label="Edit Inventory"
          (click)="edit()"
        >
          <span class="icon">
            <app-svg-icon svgIcon="pen-cc"></app-svg-icon>
          </span>
        </button>
      </div>
      <div class="info-list">
        <div class="info-row">
        </div>
      </div>
    </div> -->
    <hr />
    <div class="section">
      <div class="section-header">
        <span>{{ "inventory.organize" | translate }}</span>
        <!-- <button
          class="action-btn secondary-btn icon-btn"
          aria-label="Edit Inventory"
          (click)="edit()"
        >
          <span class="icon">
            <app-svg-icon svgIcon="pen-cc"></app-svg-icon>
          </span>
        </button> -->
      </div>
      <div class="info-list" [formGroup]="form">
        <div class="info-row column-info" *appFieldVisible="{ module: 'product', field: 'categories' }">
          <span class="label">{{
            "Categories.categories" | translate
          }}</span>
            <mat-chip-list #chipCategoryList>
              <mat-chip *ngFor="let category of categoriesSelected$ | async" (removed)="cancelCategory(category.id)">
                {{category.name}}
                <button *appHasPermission="{ module: 'product', action: 'edit' }" matChipRemove>
                  <mat-icon style="color: #868E96;">cancel</mat-icon>
                </button>
              </mat-chip>
              <input *appHasPermission="{ module: 'product', action: 'edit' }" class="input_chip" placeholder="add category" #fruitInput formControlName="categoryControl"
                [matAutocomplete]="autoCategory" [matChipInputFor]="chipCategoryList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (blur)="onChipInputBlur('category')">
            </mat-chip-list>
            <mat-autocomplete #autoCategory="matAutocomplete">
              <ng-container *ngIf="filteredCategories$ | async as categories">
                <mat-option *ngFor="let category of categories" [value]="category.name" (click)="onCategorySelected(category)">
                  {{category.name}}
                </mat-option>
              </ng-container>
            </mat-autocomplete>
        </div>
        <div class="info-row column-info">
          <span class="label">{{
            "inventory.product_details.labels" | translate
          }}</span>
          <mat-chip-list #chipList>
            <mat-chip *ngFor="let tag of tagsSelected$ | async" (removed)="cancelTag(tag.id)">
              {{tag.name}}
              <button *appHasPermission="{ module: 'product', action: 'edit' }" matChipRemove>
                <mat-icon style="color: #868E96;">cancel</mat-icon>
              </button>
            </mat-chip>
            <input *appHasPermission="{ module: 'product', action: 'edit' }" class="input_chip" placeholder="add tag" #fruitInput formControlName="tagControl"
              [matAutocomplete]="autoTag" [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (blur)="onChipInputBlur('tag')">
          </mat-chip-list>
          <mat-autocomplete #autoTag="matAutocomplete">
            <ng-container *ngIf="filteredTags$ | async as tags">
              <mat-option *ngFor="let tag of tags" [value]="tag.name" (click)="onTagSelected(tag)">
                {{tag.name}}
              </mat-option>
            </ng-container>
          </mat-autocomplete>
        </div>
      </div>
    </div>
    <hr />
    <div class="section">
      <div class="section-header">
        <span>{{ "settings.settings" | translate }}</span>
        <button
          *appHasPermission="{ module: 'product', action: 'edit' }"
          class="action-btn secondary-btn icon-btn"
          aria-label="Edit Inventory"
          (click)="editSettings()"
        >
          <span class="icon">
            <app-svg-icon svgIcon="pen-cc"></app-svg-icon>
          </span>
        </button>
      </div>
      <div class="info-list">
        <div class="info-row" *appFieldVisible="{ module: 'product', field: 'stock' }">
          <span class="label">{{
            "inventory.settings.reorder_level" | translate
          }}</span>
          <span class="value">{{getSubElementValue('reorder_point', 'stock')}}</span>
        </div>
        <div class="info-row">
          <span class="label">{{
            "inventory.settings.min_order_quantity" | translate
          }}</span>
          <span class="value">{{getProductElementValue('min_qte')}}</span>
        </div>
        <div class="info-row">
          <span class="label">{{
            "inventory.settings.increment" | translate
          }}</span>
          <span class="value">{{getProductElementValue('increment')}}</span>
        </div>
        <div class="info-row">
          <span class="label">{{
            "inventory.settings.max_order_quantity" | translate
          }}</span>
          <span class="value">{{getProductElementValue('max_qte')}}</span>
        </div>
      </div>
    </div>
    <hr />
    <div class="section" *ngIf="getProductType(product) === 'standard_product'">
      <div class="section-header">
        <span>{{"inventory.product_details.allow_oversell" | translate}}</span>
        <mat-slide-toggle
          [checked]="product.can_be_sold_out_of_stock"
          [disabled]="(canEditProduct$ | async) !== true"
          (change)="onAllowOversellChange($event)"
        ></mat-slide-toggle>
      </div>
      <div class="info-list">
        <div class="info-row">
          <span class="label description-text">{{"inventory.product_details.allow_oversell_description" | translate}}</span>
        </div>
      </div>
    </div>
    <hr />
    <div class="section">
      <div class="section-header">
        <span>{{ "custom_fields.custom_fields" | translate}}</span>
        <button
          *appHasPermission="{ module: 'product', action: 'edit' }"
          class="action-btn secondary-btn icon-btn"
          aria-label="Edit Inventory"
          (click)="editCustomFields()"
        >
          <span class="icon">
            <app-svg-icon svgIcon="pen-cc"></app-svg-icon>
          </span>
        </button>
      </div>
      <div class="info-list">
        <app-object-custom-fields-view
          [objectCustomFields]="objectCustomFields"
          [currentLanguage]="currentLanguage"
        ></app-object-custom-fields-view>
      </div>
    </div>
  </div>